import { useEffect, useState } from 'react';

// Returns a `Date.now()` value that re-renders the consumer every `intervalMs`
// milliseconds. Use it to keep relative-time chips ("5m ago" → "6m ago") fresh
// without a full page reload. Default cadence is 30s — fast enough for the
// minute boundary, light enough to ignore re-render cost.
export const useNow = (intervalMs = 30_000) => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
};
